import { Box, Modal, Typography, useMediaQuery } from "@mui/material";
import classes from "../../../styles/imagePreview.module.css";
import SliderWrapper from "src/globalModule/components/reactSlick/_SlickSliderStyle";
import Slider from "react-slick";
import Image from "next/legacy/image";
import { useTranslation } from "react-i18next";
import { WhatsApp } from "@mui/icons-material";
import { WEB_ENGAGE } from "@utils/constants";
import PujaRegisterButton from "./PujaRegisterButton";
import { WhatsappShareButton } from "react-share";
import { useRouter } from "next/router";
import CloseIcon from "@mui/icons-material/Close";
const ImagePreviewModal = ({
  openImagePreview,
  handlePreviewModal,
  data,
  handleToRegister,
  setOpenImagePreview
}) => {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const bigScreen = useMediaQuery("(min-width:768px)");
  // console.log("url", router.asPath);
  const currentUrl = process.env.NEXT_PUBLIC_APP_HOSTNAME + router.asPath;

  // const currentUrl = window.location.origin + router.asPath;

  // const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    speed: 500,
    arrows: false,
    adaptiveHeight: true,
    appendDots: dots => <ul>{dots}</ul>,
    customPaging: i => <div className="ft-slick__dots--custom">
        <div className="loading" />
      </div>
    // beforeChange: (current, next) => setCurrentSlide(next),
  };
  const handleToRegisterFromModal = () => {
    handlePreviewModal(false);
    handleToRegister();
  };
  return <>
      {!bigScreen ? <Modal open={openImagePreview} onClose={handlePreviewModal} aria-labelledby="modal-modal-title1" aria-describedby="modal-modal-description1">
          <Box className={classes.container}>
            {/* <Navbar toHome={true} /> */}

            <div className={classes.containerItem}>
              <CloseIcon className={classes.closeIcon} onClick={() => setOpenImagePreview(false)} />
              <SliderWrapper scale={1}>
                <Slider {...settings}>
                  {data.images.map((image, index) => <div key={index} className={classes.demoImageCardWrapper}>
                      {/* <Zoom> */}
                      <Image src={image ?? ""} alt={t("temple-image")}
                // className={style.blogCardImg}
                // width={"360px"}
                // height={"270px"}
                layout="fill" objectFit="cover" placeholder="blur" blurDataURL={image ?? ""} loading="eager" priority />
                      {/* </Zoom> */}
                    </div>)}
                </Slider>
              </SliderWrapper>

              <div className={classes.whatsappShareContainer}>
                <WhatsappShareButton url={currentUrl ?? ""} separator={"\n\n"} title={data.name + "\n\n👇Click here to register for this Puja on Utsav👇"}
            // className={blogClasses.whatsapp_share_btn}
            onClick={() => {}}>
                  <div className={classes.whatsappShare}>
                    <WhatsApp className={classes.whatsappIcon} />

                    <Typography sx={{
                  color: "white"
                }}>
                      {t("share")}
                    </Typography>
                  </div>
                </WhatsappShareButton>
              </div>

              <div className={classes.supportContainer}>
                <div className={classes.mobileBookButtonContainer}>
                  <PujaRegisterButton data={data} clicked_from={WEB_ENGAGE.CLICKED_FROMS.BOTTOM_BUTTON} handleToRegister={handleToRegisterFromModal} visibleBookBtn={true} //visibleBookBtn
              />
                </div>
              </div>
            </div>
          </Box>
        </Modal> : <Modal open={openImagePreview} onClose={() => setOpenImagePreview(false)} aria-labelledby="modal-modal-title2" aria-describedby="modal-modal-description2">
          <Box className={classes.container}>
            <div className={classes.containerItem}>
              <CloseIcon className={classes.closeIcon} onClick={() => setOpenImagePreview(false)} />
              <SliderWrapper scale={1}>
                <Slider {...settings}>
                  {data.images.map((image, index) => <div key={index} className={classes.demoImageCardWrapper}>
                      {/* <Zoom> */}
                      <Image src={image ?? ""} alt={t("temple-image")}
                // className={style.blogCardImg}
                // width={"360px"}
                // height={"270px"}
                layout="fill" objectFit="cover" placeholder="blur" blurDataURL={image ?? ""} loading="eager" priority />
                      {/* </Zoom> */}
                    </div>)}
                </Slider>
              </SliderWrapper>

              <div className={classes.supportContainer}>
                <div className={classes.mobileBookButtonContainer}>
                  <PujaRegisterButton data={data} clicked_from={WEB_ENGAGE.CLICKED_FROMS.BOTTOM_BUTTON} handleToRegister={handleToRegisterFromModal} visibleBookBtn={true} //visibleBookBtn
              />
                </div>
              </div>
            </div>
          </Box>
        </Modal>}
    </>;
};
export default ImagePreviewModal;